"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function PrecisionPsychiatryForModernLife() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="precision-psychiatry-for-modern-life" className="relative w-full min-h-[calc(100vh-4rem)] flex flex-col lg:flex-row bg-background overflow-hidden">
      {}
      <div className="w-full lg:w-1/2 relative h-[50vh] lg:h-auto bg-muted order-1 lg:order-1">
        <img src="https://vast-cheetah.10web.cloud/wp-content/uploads/2026/04/Gemini_Generated_Image_5xi8nd5xi8nd5xi8-scaled.png" alt="Dr. Sharmat and Maryellen Stephens in their modern NYC office" className="absolute inset-0 w-full h-full object-cover" />
        {}
        <div className="absolute inset-0 bg-[var(--background)]/10 mix-blend-overlay pointer-events-none" />
      </div>

      {}
      <div className="w-full lg:w-1/2 flex items-center justify-center p-8 md:p-16 lg:p-24 xl:p-32 order-2 lg:order-2">
        <div ref={ref} className="max-w-xl flex flex-col items-start text-left">
          {}
          <h1 className={`font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-primary mb-6 leading-[1.1] transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            Precision Psychiatry for Modern Life
          </h1>

          {}
          <p className={`text-lg md:text-xl text-muted-foreground mb-10 leading-relaxed transition-all duration-1000 delay-200 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>Sharmat Psychiatric Group combines cutting‑edge genetic evaluation with personalized medication management. We combine advanced science with a patient‑centered focus to provide compassionate care for complex cases and patients of all ages.</p>

          {}
          <div className={`transition-all duration-1000 delay-400 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <Button asChild size="lg" className="bg-[var(--ring)] hover:bg-[var(--ring)]/90 text-white border-none shadow-lg hover:shadow-xl transition-all h-14 px-8 rounded-full text-lg font-medium">
              <Link to="https://sharmatpsychiatricgroup.com/contact/">
                Book a Consultation
                <ArrowRight className="ml-2 size-5" />
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}